import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ModalComponent } from "../modal.component";

@Component({
    selector: "s25-ng-modal-edit-event-form-config",
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-event-form-config
                        [id]="data.id"
                        [mode]="data.mode"
                        (saved)="onSaved()"
                        (cancelled)="onCancelled()"
                    ></s25-ng-event-form-config>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditEventFormConfigComponent
    extends ModalComponent<{
        id?: number;
        mode?: "create" | "copy" | "edit";
        onSave?: () => unknown;
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit: boolean = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.closeModal();
        this.data.onSave?.();
    }

    onCancelled() {
        this.data.closeModal();
        this.data.onCancel?.();
    }
}
